import { Component, OnInit, Inject } from '@angular/core';
import { ErrorList } from '../../../shared-components/controls/error-prompt/error-list.model';
import { Subscription } from 'rxjs';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ProgramAndServiceService } from '../program-and-service.service';
import { ProgramAndService } from '../../../student360/programs-and-services/programs-and-services.model';

@Component({
  selector: 'app-delete-program-service-dialog',
  templateUrl: './delete-program-service-dialog.component.html',
  styleUrls: ['./delete-program-service-dialog.component.css']
})
export class DeleteProgramServiceDialogComponent implements OnInit {

 // Injected Properties
 id: number;
 programAndServices: ProgramAndService[] = [];
 type = '';
 title: string;
 message: string;

 // Local Properties
 errors: ErrorList[] = [];
 subscriptions: Subscription[] = [];

 // Class Functions
 constructor(
   @Inject(MAT_DIALOG_DATA) private data: any,
   private dialogBox: MatDialogRef<any, any>,
   private programsAndServicesService: ProgramAndServiceService,
 ) { }

 // Event Functions
 ngOnInit() {
   // POST: initializes the data
   if (this.data) {
     if (this.data.id) {
      this.id = this.data.id;
     }
     if (this.data.programAndServices) {
       this.programAndServices = this.data.programAndServices;
     }
     this.type = this.data.type;
     this.title = this.data.title;
     this.message = this.data.message;
   }
 }

 ngOnDestroy() {
   this.subscriptions.forEach(subscription => {
     subscription.unsubscribe();
   });
 }

 OK() {
   // PRE: the OK button is clicked
   // POST: deletes the program code, service code and field and closes the dialog
   if (this.type == 'delete') {
     this.subscriptions.push(
      // Delete program code
      this.programsAndServicesService.deleteProgramService(this.id).subscribe(res => {
        if (res) {
          this.dialogBox.close(true);
        }
      })
     );
    }
   else if (this.type == 'mass-delete') {

    this.subscriptions.push(
      // Delete program code
      this.programsAndServicesService.massDeleteProgramService(this.programAndServices).subscribe(res => {
        if (res != null && res == 'Successful') {
          this.dialogBox.close(true);
        }
        else {
          this.message = res;
        }
      })
     );
   }
 }

 cancel() {
   // PRE: the cancel button is clicked
   // POST: closes the dialog
   this.dialogBox.close(false);
 }
}

